import { getJson } from './client';
import type { Snapshot } from './types';
export const fetchSnapshot = () => getJson<Snapshot>('/api/snapshot');
